"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LIGHT_ACTION_LOG = void 0;
/**
 * Action type (for log)
 */
var LIGHT_ACTION_LOG;
(function (LIGHT_ACTION_LOG) {
    LIGHT_ACTION_LOG["ROUTE_OVERRIDE"] = "ROUTE_OVERRIDE";
    LIGHT_ACTION_LOG["META_EXPR_ERROR"] = "META_EXPR_ERROR";
    LIGHT_ACTION_LOG["ATTACHMENT_SYNC_ERROR"] = "ATTACHMENT_SYNC_ERROR";
    LIGHT_ACTION_LOG["IMAGE_COMPRESSION_WARNING"] = "IMAGE_COMPRESSION_WARNING";
    LIGHT_ACTION_LOG["TOO_MANY_IMPORTANT_ATTRIBUTE"] = "TOO_MANY_IMPORTANT_ATTRIBUTE";
    LIGHT_ACTION_LOG["TOO_MANY_MOBILE_USERS"] = "TOO_MANY_MOBILE_USERS";
    LIGHT_ACTION_LOG["TOO_MANY_WEB_USERS"] = "TOO_MANY_WEB_USERS";
    LIGHT_ACTION_LOG["TOO_MANY_TEAMS"] = "TOO_MANY_TEAMS";
    LIGHT_ACTION_LOG["TOO_MANY_ATTRIBUTES_QUESTIONS"] = "TOO_MANY_ATTRIBUTES_QUESTIONS";
    LIGHT_ACTION_LOG["TOO_MANY_CALCULATED_ATTRIBUTES"] = "TOO_MANY_CALCULATED_ATTRIBUTES";
    LIGHT_ACTION_LOG["TOO_MANY_PICTURE_ATTRIBUTES"] = "TOO_MANY_PICTURE_ATTRIBUTES";
    LIGHT_ACTION_LOG["SC_MC_ISSUE"] = "SC_MC_ISSUE";
    LIGHT_ACTION_LOG["BIG_LIST_ISSUE"] = "BIG_LIST_ISSUE";
    LIGHT_ACTION_LOG["TOO_MANY_UNIQUE_ATTRIBUTES"] = "TOO_MANY_UNIQUE_ATTRIBUTES";
    LIGHT_ACTION_LOG["TOO_MANY_DOCUMENTS"] = "TOO_MANY_DOCUMENTS";
    LIGHT_ACTION_LOG["TOO_MANY_OPTIONS"] = "TOO_MANY_OPTIONS";
    LIGHT_ACTION_LOG["TOO_MANY_QUESTIONS"] = "TOO_MANY_QUESTIONS";
    LIGHT_ACTION_LOG["ACCESS_RIGHTS_MISMATCH"] = "ACCESS_RIGHTS_MISMATCH";
    LIGHT_ACTION_LOG["VISIT_SYNC_ERROR"] = "VISIT_SYNC_ERROR";
    LIGHT_ACTION_LOG["ACTIVITY_REPORT_SYNC_ERROR"] = "ACTIVITY_REPORT_SYNC_ERROR";
    LIGHT_ACTION_LOG["WORKFLOW_REPORT_SYNC_ERROR"] = "WORKFLOW_REPORT_SYNC_ERROR";
})(LIGHT_ACTION_LOG || (exports.LIGHT_ACTION_LOG = LIGHT_ACTION_LOG = {}));
